import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A stationary battery bank: a steel rack of two shelves holding eight block
// cells, each with red and black terminals linked by orange busbar straps. The
// backup energy store behind a substation or telecom site.
const FRAME = "#6c727a";
const CELL = "#2b323a";
const CELL_TOP = "#3a424b";
const POS = "#c4392f";
const NEG = "#222226";
const LINK = "#caa033";

function cell(x: number, y: number, z: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.16), color: CELL, position: [x, y, z] },
    { geometry: new THREE.BoxGeometry(0.2, 0.03, 0.16), color: CELL_TOP, position: [x, y + 0.1, z] },
    { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.04, 8), color: POS, position: [x - 0.05, y + 0.12, z] },
    { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.04, 8), color: NEG, position: [x + 0.05, y + 0.12, z] },
  ];
}

export const batteryBank = defineModel({
  id: "battery-bank",
  batchId: "electric",
  name: "Battery bank",
  tags: ["prop", "electric", "power", "storage", "battery"],
  summary: "A steel rack of cells with terminals and busbar links.",
  footprint: 0.5,
  parts(): Part[] {
    const parts: Part[] = [];
    // Rack: four posts and two shelves.
    for (const x of [-0.46, 0.46]) for (const z of [-0.12, 0.12]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.04, 0.7, 0.04), color: FRAME, position: [x, 0.35, z] });
    }
    for (const y of [0.12, 0.42]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.98, 0.03, 0.32), color: FRAME, position: [0, y, 0] });
    }
    // Eight cells in two rows of four.
    const xs = [-0.33, -0.11, 0.11, 0.33];
    for (const y of [0.25, 0.55]) for (const x of xs) parts.push(...cell(x, y, 0));
    // Busbar straps linking the top terminals of each row.
    for (const y of [0.37, 0.67]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.78, 0.02, 0.03), color: LINK, position: [0, y, 0.02] });
    }
    return parts;
  },
  animations: [],
});
